// Generated by BEAR https://rndwww.nce.amadeus.net/git/projects/SECO/repos/bear/browse
class Bear1AXMLService {
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: PNR_Retrieve
     * - Command: PNRRET
     * - Version: 1A
     * - Id: 18.2
     */
    pnrRetrieve(rq) {
        return this.call('PnrRetrieve', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: PNR_AddMultiElements
     * - Command: PNRADD
     * - Version: 1A
     * - Id: 18.2
     */
    pnrAdd(rq) {
        return this.call('PnrAdd', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: PNR_Cancel
     * - Command: PNRXCL
     * - Version: 1A
     * - Id: 18.2
     */
    pnrCancel(rq) {
        return this.call('PnrCancel', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: PNR_NameChange
     * - Command: NMEREQ
     * - Version: 1A
     * - Id: 14.1
     */
    pnrNameChange(rq) {
        return this.call('PnrNameChange', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: PNR_Retrieve
     * - Command: PNRRET
     * - Version: 1A
     * - Id: 18.2
     */
    pnrList(rq) {
        return this.call('PnrList', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: PNR_ReduceNIP
     * - Command: PRNPUQ
     * - Version: 1A
     * - Id: 04.1
     */
    pnrReduceNip(rq) {
        return this.call('PnrReduceNip', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: PNR_Search
     * - Command: PAUSRQ
     * - Version: 1A
     * - Id: 18.1
     */
    pnrSearch(rq) {
        return this.call('PnrSearch', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: PNR_Replicate
     * - Command: PRPLCQ
     * - Version: 1A
     * - Id: 22.1
     */
    pnrReplicate(rq) {
        return this.call('PnrReplicate', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: PNR_DisplayHistory
     * - Command: PHIDRQ
     * - Version: 1A
     * - Id: 16.1
     */
    pnrDisplayHistory(rq) {
        return this.call('PnrDisplayHistory', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Queue_CountTotal
     * - Command: QCSDRQ
     * - Version: 1A
     * - Id: 19.1
     */
    queueManagementCountTotal(rq) {
        return this.call('QueueManagementCountTotal', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Queue_List
     * - Command: QDQLRQ
     * - Version: 1A
     * - Id: 19.1
     */
    queueManagementList(rq) {
        return this.call('QueueManagementList', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Queue_PlacePNR
     * - Command: QUQPCQ
     * - Version: 1A
     * - Id: 03.1
     */
    queuePlacePnr(rq) {
        return this.call('QueuePlacePnr', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Queue_RemoveItem
     * - Command: QUQMDQ
     * - Version: 1A
     * - Id: 03.1
     */
    queueRemoveItem(rq) {
        return this.call('QueueRemoveItem', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: QueueMode_ProcessQueue
     * - Command: QUEREQ
     * - Version: IA
     * - Id: 09.1
     */
    queueModeProcessQueue(rq) {
        return this.call('QueueModeProcessQueue', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_ServiceBookPriceServiceRQ
     * - Command: AMA_ServiceBookPriceServiceRQ
     * - Version: 1.1
     * - Id: AMA
     */
    bookPriceService(rq) {
        return this.call('BookPriceService', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: FileRetrieveRQ
     * - Command: FileRetrieveRQ
     * - Version: 2.0
     * - Id: IATA2016.2
     */
    fileRetrieve(rq) {
        return this.call('FileRetrieve', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Air_RetrieveSeatMap
     * - Command: SMPREQ
     * - Version: 1A
     * - Id: 17.1
     */
    retrieveSeatMap(rq) {
        return this.call('RetrieveSeatMap', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Air_SellFromRecommendation
     * - Command: ITAREQ
     * - Version: IA
     * - Id: 05.2
     */
    airSell(rq) {
        return this.call('AirSell', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Air_FlightInfo
     * - Command: FLIREQ
     * - Version: 1A
     * - Id: 07.1
     */
    airFlightInfo7(rq) {
        return this.call('AirFlightInfo7', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Air_RebookAirSegment
     * - Command: ARBKUQ
     * - Version: 1A
     * - Id: 20.1
     */
    airRebookAirSegment(rq) {
        return this.call('AirRebookAirSegment', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: MiniRule_GetFromRec
     * - Command: TMRXRQ
     * - Version: 1A
     * - Id: 18.1
     */
    miniRuleGetFromRec(rq) {
        return this.call('MiniRuleGetFromRec', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Offer_CreateOffer
     * - Command: POFRCQ
     * - Version: 1A
     * - Id: 11.2
     */
    createOffer(rq) {
        return this.call('CreateOffer', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Fare_MasterPricerTravelBoardSearch
     * - Command: FMPTBQ
     * - Version: 1A
     * - Id: 24.1
     */
    masterPricerSearch(rq) {
        return this.call('MasterPricerSearch', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Fare_MasterPricerTravelBoardSearch232
     * - Command: FMPTBQ232
     * - Version: 1A
     * - Id: 23.2
     */
    masterPricerSearch232(rq) {
        return this.call('MasterPricerSearch232', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Fare_MasterPricerCalendar
     * - Command: FMPCAQ
     * - Version: 1A
     * - Id: 20.2
     */
    masterPricerCalendarSearch(rq) {
        return this.call('MasterPricerCalendarSearch', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_NGFeeFeeModelRetrieveListRQ
     * - Command: MFEMLQ
     * - Version: 1.0
     * - Id: WS
     */
    marginManagerModelRetrieve(rq) {
        return this.call('MarginManagerModelRetrieve', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Fare_InformativePricingWithoutPNR
     * - Command: TIPNRQ
     * - Version: 1A
     * - Id: 13.2
     */
    fareInfoPricing(rq) {
        return this.call('FareInfoPricing', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Fare_PricePNRWithBookingClass
     * - Command: TPCBRQ
     * - Version: 1A
     * - Id: 18.1
     */
    farePriceWithBookingClass(rq) {
        return this.call('FarePriceWithBookingClass', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Fare_PricePNRWithBookingClass
     * - Command: TPCBRQ
     * - Version: 1A
     * - Id: 23.2
     */
    farePriceWithBookingClass23(rq) {
        return this.call('FarePriceWithBookingClass23', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Fare_PricePNRWithLowerFares
     * - Command: TPLFRQ
     * - Version: 1A
     * - Id: 23.2
     */
    farePricePNRWithLowerFares(rq) {
        return this.call('FarePricePNRWithLowerFares', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Fare_PricePNRWithLowestFare
     * - Command: TPLPRQ
     * - Version: 1A
     * - Id: 23.2
     */
    farePricePNRWithLowestFare(rq) {
        return this.call('FarePricePNRWithLowestFare', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Fare_PriceUpsellPNR
     * - Command: TPUPRQ
     * - Version: 1A
     * - Id: 23.2
     */
    farePriceUpsellPNR(rq) {
        return this.call('FarePriceUpsellPNR', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Fare_PriceUpsellWithoutPNR
     * - Command: TIUNRQ
     * - Version: 1A
     * - Id: 23.1
     */
    farePriceUpsellWithoutPNR(rq) {
        return this.call('FarePriceUpsellWithoutPNR', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Fare_GetFareFamilyDescription
     * - Command: TFQFRQ
     * - Version: 1A
     * - Id: 15.1
     */
    fareGetFareFamilyDescription(rq) {
        return this.call('FareGetFareFamilyDescription', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Fare_CheckRules
     * - Command: FARQNQ
     * - Version: 1A
     * - Id: 07.1
     */
    fareCheckRules(rq) {
        return this.call('FareCheckRules', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Fare_CheckRules
     * - Command: FARQNQ
     * - Version: 1A
     * - Id: 19.1
     */
    fareCheckRules19(rq) {
        return this.call('FareCheckRules19', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Fare_GetFareRules
     * - Command: FARRNQ
     * - Version: 1A
     * - Id: 10.1
     */
    fareGetFareRules(rq) {
        return this.call('FareGetFareRules', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_FareGetContextKeysRQ
     * - Command: AMA_FareGetContextKeysRQ
     * - Version: 1.0
     * - Id: AMA2018N
     */
    fareGetContextKeys(rq) {
        return this.call('FareGetContextKeys', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Ticket_RetrieveListOfQuotation
     * - Command: TPQIRQ
     * - Version: 1A
     * - Id: 16.1
     */
    retrieveListOfQuotation(rq) {
        return this.call('RetrieveListOfQuotation', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Ticket_DisplayTST
     * - Command: TTSTRQ
     * - Version: 1A
     * - Id: 15.1
     */
    displayTST15(rq) {
        return this.call('DisplayTST15', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Ticket_DisplayTSMP
     * - Command: TTSMRQ
     * - Version: 1A
     * - Id: 15.1
     */
    displayTSMP15(rq) {
        return this.call('DisplayTSMP15', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Ticket_DeleteTST
     * - Command: TTSTDQ
     * - Version: 1A
     * - Id: 04.1
     */
    deleteTST(rq) {
        return this.call('DeleteTST', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Ticket_DeleteTSMP
     * - Command: TTSMDQ
     * - Version: 1A
     * - Id: 08.1
     */
    deleteTSMP(rq) {
        return this.call('DeleteTSMP', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Ticket_GetPricingOptions
     * - Command: TPORRQ
     * - Version: 1A
     * - Id: 19.1
     */
    ticketGetPricingOptions(rq) {
        return this.call('TicketGetPricingOptions', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Ticket_CreateTSTFromPricing
     * - Command: TAUTCQ
     * - Version: 1A
     * - Id: 04.1
     */
    ticketCreateTST(rq) {
        return this.call('TicketCreateTST', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: DocIssuance_IssueCombined
     * - Command: TCTMIQ
     * - Version: 1A
     * - Id: 15.1
     */
    docIssueCombined(rq) {
        return this.call('DocIssueCombined', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: DocIssuance_IssueTicket
     * - Command: TTKTIQ
     * - Version: 1A
     * - Id: 15.1
     */
    docIssuanceIssueTicket(rq) {
        return this.call('DocIssuanceIssueTicket', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: DocIssuance_IssueMiscellaneousDocuments
     * - Command: TMDSIQ
     * - Version: 1A
     * - Id: 15.1
     */
    docIssuanceIssueMiscellaneousDocuments(rq) {
        return this.call('DocIssuanceIssueMiscellaneousDocuments', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Ticket_ProcessEDoc
     * - Command: TATREQ
     * - Version: 1A
     * - Id: 13.1
     */
    ticketProcessEDoc(rq) {
        return this.call('TicketProcessEDoc', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_TicketCancelTransactionRQ
     * - Command: Ticket_CancelTransaction
     * - Version: 1.2
     * - Id: WS
     */
    ticket_CancelTransaction(rq) {
        return this.call('Ticket_CancelTransaction', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Ticket_CheckEligibility
     * - Command: FATCEQ
     * - Version: 1A
     * - Id: 16.1
     */
    ticket_CheckEligibility(rq) {
        return this.call('Ticket_CheckEligibility', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Ticket_RepricePNRWithBookingClass
     * - Command: TARIPQ
     * - Version: 1A
     * - Id: 12.2
     */
    ticket_RepricePNRWithBookingClass(rq) {
        return this.call('Ticket_RepricePNRWithBookingClass', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Ticket_ReissueConfirmedPricing
     * - Command: TARCPQ
     * - Version: 1A
     * - Id: 13.2
     */
    ticket_ReissueConfirmedPricing(rq) {
        return this.call('Ticket_ReissueConfirmedPricing', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Ticket_ATCShopperMasterPricerTravelBoardSearch
     * - Command: FMTCTQ
     * - Version: 1A
     * - Id: 18.2
     */
    ticket_ATCShopperMasterPricerTravelBoardSearch(rq) {
        return this.call('Ticket_ATCShopperMasterPricerTravelBoardSearch', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Ticket_RetrieveListOfTSM
     * - Command: TTSLRQ
     * - Version: 1A
     * - Id: 09.1
     */
    ticket_RetrieveListOfTSM(rq) {
        return this.call('Ticket_RetrieveListOfTSM', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: FOP_ReadFormOfPaymentData
     * - Command: TFOPRQ
     * - Version: 1A
     * - Id: 15.3
     */
    readFormOfPaymentData(rq) {
        return this.call('ReadFormOfPaymentData', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: GetFOPCatalog
     * - Command: TFPLCQ
     * - Version: 1A
     * - Id: 18.1
     */
    getFopList(rq) {
        return this.call('GetFopList', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: FOP_DeleteFormOfPayment
     * - Command: TFOPDQ
     * - Version: 1A
     * - Id: 14.5
     */
    deleteFormOfPaymentData(rq) {
        return this.call('DeleteFormOfPaymentData', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: FOP_CreateFopInternal
     * - Command: TFPICQ
     * - Version: 1A
     * - Id: 15.3
     */
    createFormOfPayment(rq) {
        return this.call('CreateFormOfPayment', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: FOP_CreateFormOfPayment
     * - Command: TFOPCQ
     * - Version: 1A
     * - Id: 20.4
     */
    createFormOfPaymentExternal(rq) {
        return this.call('CreateFormOfPaymentExternal', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_TTR_DisplayTrip
     * - Command: AMA_TTR_DisplayTrip
     * - Version: 11.0
     * - Id: WS
     */
    displayTrip11(rq) {
        return this.call('DisplayTrip11', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: TTR_ManageTrip
     * - Command: TTR_ManageTrip
     * - Version: 11.0
     * - Id: WS
     */
    manageTrip11(rq) {
        return this.call('ManageTrip11', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_TravelOrderRetrieveRQ
     * - Command: AMA_TravelOrderRetrieveRQ
     * - Version: 1.0
     * - Id: AMA
     */
    travelOrderRetrieve(rq) {
        return this.call('TravelOrderRetrieve', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_TravelOrderReshopRQ
     * - Command: Travel_OrderReshop
     * - Version: 1.0
     * - Id: WS
     */
    travelOrderReshop(rq) {
        return this.call('TravelOrderReshop', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_TravelOfferPriceRQ
     * - Command: Travel_OfferPrice
     * - Version: 1.4
     * - Id: WS
     */
    travelOfferPrice(rq) {
        return this.call('TravelOfferPrice', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_TravelOrderCancelRQ
     * - Command: AMA_TravelOrderCancelRQ
     * - Version: 1.0
     * - Id: WS
     */
    travelOrderCancel(rq) {
        return this.call('TravelOrderCancel', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_TravelOrderChangeRQ
     * - Command: AMA_TravelOrderChangeRQ
     * - Version: 1.0
     * - Id: AMA
     */
    travelOrderChange(rq) {
        return this.call('TravelOrderChange', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_TravelOrderCreateRQ
     * - Command: AMA_TravelOrderCreateRQ
     * - Version: 1.0
     * - Id: AMA
     */
    travelOrderCreate(rq) {
        return this.call('TravelOrderCreate', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_TravelOrderPayRQ
     * - Command: AMA_TravelOrderPayRQ
     * - Version: 1.0
     * - Id: WS
     */
    travelOrderPay(rq) {
        return this.call('TravelOrderPay', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_TravelSeatAvailabilityRQ
     * - Command: AMA_TravelSeatAvailabilityRQ
     * - Version: 1.0
     * - Id: WS
     */
    travelSeatAvailability(rq) {
        return this.call('TravelSeatAvailability', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_TravelServiceListRQ
     * - Command: Travel_ServiceList
     * - Version: 1.1
     * - Id: WS
     */
    travelServiceList(rq) {
        return this.call('TravelServiceList', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: RetrieveFvQuery
     * - Command: MFVIRQ
     * - Version: SAMCTX
     * - Id: 17.1
     */
    retrieveFv(rq) {
        return this.call('RetrieveFv', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: FiPackageCreationQuery
     * - Command: MOFPCQ
     * - Version: SAMCTX
     * - Id: 11.1
     */
    fiPackageCreation(rq) {
        return this.call('FiPackageCreation', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: FiPackageUpdateQuery
     * - Command: MOFPUQ
     * - Version: SAMCTX
     * - Id: 11.1
     */
    fiPackageUpdate(rq) {
        return this.call('FiPackageUpdate', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: UpdateFvQuery
     * - Command: MFVIUQ
     * - Version: SAMCTX
     * - Id: 17.1
     */
    updateFv(rq) {
        return this.call('UpdateFv', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Insurance_ProviderList
     * - Command: IAVREQ
     * - Version: 1A
     * - Id: 10.1
     */
    insuranceProviderList(rq) {
        return this.call('InsuranceProviderList', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Insurance_ProductList
     * - Command: IADREQ
     * - Version: 1A
     * - Id: 10.1
     */
    insuranceProductList(rq) {
        return this.call('InsuranceProductList', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Insurance_Pricing
     * - Command: IPRICQ
     * - Version: 1A
     * - Id: 13.1
     */
    insurancePricing(rq) {
        return this.call('InsurancePricing', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Insurance_Booking
     * - Command: IBOKCQ
     * - Version: 1A
     * - Id: 13.1
     */
    insuranceBooking(rq) {
        return this.call('InsuranceBooking', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Insurance_Features
     * - Command: IATREQ
     * - Version: 1A
     * - Id: 14.1
     */
    insuranceFeatures(rq) {
        return this.call('InsuranceFeatures', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Insurance_Proposal
     * - Command: ISSORQ
     * - Version: 1A
     * - Id: 13.1
     */
    insuranceProposal(rq) {
        return this.call('InsuranceProposal', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_TransferSearchAvailabilityRQ
     * - Command: AMA_TransferSearchAvailabilityRQ
     * - Version: 2.000
     * - Id: AMA2023M
     */
    transferSearchAvailability(rq) {
        return this.call('TransferSearchAvailability', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Command_Cryptic
     * - Command: HSFREQ_07_3_1A
     * - Version: 1A
     * - Id: 07.3
     */
    commandCryptic(rq) {
        return this.call('CommandCryptic', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_ProfileReadRQ
     * - Command: Profile_ReadRQ
     * - Version: 1.0
     * - Id: OPS_GDS
     */
    profileReadRQ(rq) {
        return this.call('ProfileReadRQ', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_ProfileReadRQ
     * - Command: Profile_ReadRQ
     * - Version: 1.0
     * - Id: OPS_GDS
     */
    profileRead(rq) {
        return this.call('ProfileRead', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_DeleteRQ
     * - Command: Profile_DeleteRQ
     * - Version: 1.0
     * - Id: OPS_GDS
     */
    deleteRQ(rq) {
        return this.call('DeleteRQ', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_ProfileSearchRQ
     * - Command: Profile_SearchRQ
     * - Version: 1.0
     * - Id: OPS_IT
     */
    profileSearchRQ(rq) {
        return this.call('ProfileSearchRQ', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_ProfileReadRQ
     * - Command: Profile_ReadRQ
     * - Version: 1.0
     * - Id: OPS_IT
     */
    profileReadRQ_OPSIT(rq) {
        return this.call('ProfileReadRQ_OPSIT', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Profile_DeactivateProfile
     * - Command: ATPREQ
     * - Version: 1A
     * - Id: 02.1
     */
    deactivateProfile(rq) {
        return this.call('DeactivateProfile', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_UpdateRQ
     * - Command: Profile_UpdateRQ
     * - Version: 1.0
     * - Id: OPS_GDS
     */
    profileUpdateRQ(rq) {
        return this.call('ProfileUpdateRQ', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Security_AuthenticateInLSS
     * - Command: VGUIAQ
     * - Version: 1A
     * - Id: 14.1
     */
    securityAuthenticateInLSS(rq) {
        return this.call('SecurityAuthenticateInLSS', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Security_RetrievePermissions
     * - Command: VLPERQ
     * - Version: 1A
     * - Id: 09.1
     */
    securityRetrievePermissions(rq) {
        return this.call('SecurityRetrievePermissions', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Security_RetrieveUsersByPermission
     * - Command: VURCRQ
     * - Version: 1A
     * - Id: 12.1
     */
    securityRetrieveUsersByPermission(rq) {
        return this.call('SecurityRetrieveUsersByPermission', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Security_GetTemporaryPassword
     * - Command: VTPWRQ
     * - Version: 1A
     * - Id: 10.1
     */
    securityGetTemporaryPassword(rq) {
        return this.call('SecurityGetTemporaryPassword', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Security_GetAvailableDataForPermission
     * - Command: VLDARQ
     * - Version: 1A
     * - Id: 12.1
     */
    securityGetAvailableDataForPermission(rq) {
        return this.call('SecurityGetAvailableDataForPermission', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Security_GetPublicKey
     * - Command: VRSARQ
     * - Version: 1A
     * - Id: 07.1
     */
    securityGetPublicKey(rq) {
        return this.call('SecurityGetPublicKey', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: RFD_TargetObjectAttributesRetrieve
     * - Command: VTOARQ
     * - Version: 1A
     * - Id: 08.1
     */
    rFDTargetObjectAttributesRetrieve(rq) {
        return this.call('RFDTargetObjectAttributesRetrieve', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Security_GetLoginAreas
     * - Command: Security_GetLoginAreas
     * - Version: 2.0
     * - Id: WS
     */
    securityGetLoginAreas(rq) {
        return this.call('SecurityGetLoginAreas', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Security_RetrieveParentNode
     * - Command: VPNORQ
     * - Version: 1A
     * - Id: 09.1
     */
    securityRetrieveParentNode(rq) {
        return this.call('SecurityRetrieveParentNode', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Security_RemoteJump
     * - Command: VURJRQ
     * - Version: 1A
     * - Id: 15.1
     */
    securityRemoteJump(rq) {
        return this.call('SecurityRemoteJump', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_SecurityCreateMetagroupRQ
     * - Command: Security_CreateMetagroup
     * - Version: 1.0
     * - Id: WS
     */
    createMetagroup(rq) {
        return this.call('CreateMetagroup', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_SecurityUpdateMetagroupRQ
     * - Command: Security_UpdateMetagroup
     * - Version: 1.0
     * - Id: WS
     */
    updateMetagroup(rq) {
        return this.call('UpdateMetagroup', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AMA_SecuritySearchMetagroupRQ
     * - Command: Security_SearchMetagroup
     * - Version: 1.0
     * - Id: WS
     */
    searchMetagroup(rq) {
        return this.call('SearchMetagroup', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Office_Display
     * - Command: OIDREQ
     * - Version: 1A
     * - Id: 02.2
     */
    officeDisplay(rq) {
        return this.call('OfficeDisplay', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Security_RetrieveChildrenNode
     * - Command: VCNORQ
     * - Version: 1A
     * - Id: 09.1
     */
    securityRetrieveChildrenNode(rq) {
        return this.call('SecurityRetrieveChildrenNode', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: MiniRule_GetFromPricing
     * - Command: TMRCRQ
     * - Version: 1A
     * - Id: 11.1
     */
    miniRuleGetFromPricing(rq) {
        return this.call('MiniRuleGetFromPricing', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Ticket_UpdateTSMP
     * - Command: TTSMUQ
     * - Version: 1A
     * - Id: 14.1
     */
    ticketUpdateTSMP(rq) {
        return this.call('TicketUpdateTSMP', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Ticket_CreateTSMFareElement
     * - Command: TFRECQ
     * - Version: 1A
     * - Id: 10.1
     */
    ticketCreateTSMFareElement(rq) {
        return this.call('TicketCreateTSMFareElement', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Ticket_DisplayTSMFareElement
     * - Command: TFRERQ
     * - Version: 1A
     * - Id: 10.1
     */
    ticketDisplayTSMFareElement(rq) {
        return this.call('TicketDisplayTSMFareElement', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Ticket_CreateManualTSMP
     * - Command: TTSMCQ
     * - Version: 1A
     * - Id: 15.1
     */
    ticketCreateManualTSMP(rq) {
        return this.call('TicketCreateManualTSMP', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Ticket_CreateManualTST
     * - Command: TMATCQ
     * - Version: 1A
     * - Id: 07.1
     */
    ticketCreateManualTST(rq) {
        return this.call('TicketCreateManualTST', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Doc_DisplayItinerary
     * - Command: ITIRQT
     * - Version: 1A
     * - Id: 01.2
     */
    docDisplayItinerary(rq) {
        return this.call('DocDisplayItinerary', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Car_Availability
     * - Command: RCARRQ
     * - Version: 1A
     * - Id: 22.2
     */
    carAvailability(rq) {
        return this.call('CarAvailability', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Car_LocationList
     * - Command: RCLLRQ
     * - Version: 1A
     * - Id: 22.4
     */
    carLocationList(rq) {
        return this.call('CarLocationList', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Car_Modify
     * - Command: RCSSUQ
     * - Version: 1A
     * - Id: 10.1
     */
    carModify(rq) {
        return this.call('CarModify', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Car_Policy
     * - Command: RCPORQ
     * - Version: 1A
     * - Id: 14.1
     */
    carPolicy(rq) {
        return this.call('CarPolicy', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Car_RateInformationFromAvailability
     * - Command: RCFARQ
     * - Version: 1A
     * - Id: 23.2
     */
    carRateInformationFromAvailability(rq) {
        return this.call('CarRateInformationFromAvailability', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Car_RateInformationFromCarSegment
     * - Command: RCFSRQ
     * - Version: 1A
     * - Id: 21.1
     */
    carRateInformationFromCarSegment(rq) {
        return this.call('CarRateInformationFromCarSegment', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Car_RateInformationFromCarSegment
     * - Command: RCFSRQ
     * - Version: 1A
     * - Id: 23.2
     */
    carRateInformationFromCarSegment23(rq) {
        return this.call('CarRateInformationFromCarSegment23', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Car_Sell
     * - Command: RCSSCQ
     * - Version: 1A
     * - Id: 23.3
     */
    carSell(rq) {
        return this.call('CarSell', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Car_VehicleCodeList
     * - Command: RCVCRQ
     * - Version: 1A
     * - Id: 06.1
     */
    carVehicleCodeList(rq) {
        return this.call('CarVehicleCodeList', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: SalesReports_DisplayQueryReport
     * - Command: TSRQRQ
     * - Version: 1A
     * - Id: 22.2
     */
    salesReportsDisplayQueryReport(rq) {
        return this.call('SalesReportsDisplayQueryReport', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: SalesReports_DisplayTransactionReport
     * - Command: TSRTRQ
     * - Version: 1A
     * - Id: 22.2
     */
    salesReportsDisplayTransactionReport(rq) {
        return this.call('SalesReportsDisplayTransactionReport', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: AppMdw_FormatAndDeliver
     * - Command: AppMdw_FormatAndDeliver
     * - Version: 13.0
     * - Id: WS
     */
    appMdw_FormatAndDeliver(rq) {
        return this.call('AppMdw_FormatAndDeliver', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Service_IntegratedCatalogue
     * - Command: TPICGQ
     * - Version: 1A
     * - Id: 16.2
     */
    serviceIntegratedCatalogue(rq) {
        return this.call('ServiceIntegratedCatalogue', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Service_StandalonePricing
     * - Command: TPSSGQ
     * - Version: 1A
     * - Id: 15.1
     */
    serviceStandalonePricing(rq) {
        return this.call('ServiceStandalonePricing', rq);
    }
    /**
     * Calls the following 1AXML endpoint:
     * - Operation: Ticket_UpdateTST
     * - Command: TTSTUQ
     * - Version: 1A
     * - Id: 19.6
     */
    ticketUpdateTST(rq) {
        return this.call('TicketUpdateTST', rq);
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { Bear1AXMLService };
